import { debounce } from 'data/function';
import { DEFAULT_VARIABLES_NAMES } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderService';
import { ActionController, ACTION_UNDO_REDO_CHANGES } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionController';
import { BuilderFeatures } from '../../../BuilderFeatures';
import { VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
import '../Actions.scss';
import { ExecuteBlipFunctionActionSettings } from '../../../models/ExecuteBlipFunctionActionSettings';
import { FunctionViewModel } from '../../../models/viewModels/FunctionViewModel';
import { FunctionResourceMapper } from '../../../mappers/FunctionResourceMapper';
import editFunctionModal from '../components/editFunctionModal';
import deleteFunctionModal from '../components/deleteFunctionModal';
export class ExecuteBlipFunctionActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', '$translate', '$rootScope', 'UndoRedoService', 'state', '$timeout', 'CurrentApplicationService', 'FunctionService', 'BlipToastService', 'SidebarContentService', 'CodeEditorService', 'ModalService', 'ActionService', '$scope', 'typeOfAction', 'onOpenSchemaEditor'];
    constructor(close, action, $onStateChanged, $translate, $rootScope, UndoRedoService, state, $timeout, CurrentApplicationService, FunctionService, BlipToastService, SidebarContentService, CodeEditorService, ModalService, ActionService, $scope, typeOfAction, onOpenSchemaEditor) {
        super(close, action, $onStateChanged, UndoRedoService, state, {
            $rootScope,
            $scope,
            typeOfAction,
            onOpenSchemaEditor,
        });
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.$timeout = $timeout;
        this.CurrentApplicationService = CurrentApplicationService;
        this.FunctionService = FunctionService;
        this.BlipToastService = BlipToastService;
        this.SidebarContentService = SidebarContentService;
        this.CodeEditorService = CodeEditorService;
        this.ModalService = ModalService;
        this.ActionService = ActionService;
        this.itemHeight = 70;
        this.maxHeight = 330;
        this.isLoading = true;
        this.executeAction = true;
        this.createFunction = false;
        this.buttonName = '';
        this.filterFunctions = (event) => {
            this.filterFunctionName = event.detail.value;
            this.filterFunctionListByName(this.filterFunctionName);
            if (!this.$scope.$$phase) {
                this.$timeout(() => this.$scope.$apply());
            }
        };
        this.filterFunctionListByName = (filter) => {
            if (filter) {
                this.filteredFunctions = this.filteredFunctions.filter(func => func.functionName.toLowerCase().includes(filter.toLowerCase()));
                this.trackBlockActionLibrarySearch();
            }
            else {
                this.filteredFunctions = [...this.allFunctions];
            }
        };
        this.updateInputVariables = (event) => {
            const { detail: { data }, } = event;
            this.action.settings.inputVariables = data;
            this.handleSaveAction();
        };
        this.onFunctionNameChange = async (event) => {
            this.actions.functionName = event.detail.value;
            this.createFunctionForm.functionName.$invalid = false;
            this.createFunctionForm.functionName.$valid = true;
        };
        this.onDescriptionChange = (event) => {
            this.actions.description = event.detail.value;
            this.createFunctionForm.description.$invalid = false;
            this.createFunctionForm.description.$valid = true;
        };
        this.onInputVariablesChange = (event) => {
            const { detail: { data }, } = event;
            this.actions.inputVariables = data;
        };
        this.onFunctionContentChange = (event) => {
            this.actions.functionContent = event.detail.value;
            this.createFunctionForm.functionContent.$invalid = false;
            this.createFunctionForm.functionContent.$valid = true;
        };
        this.variables = DEFAULT_VARIABLES_NAMES.map(label => ({
            label,
            value: label,
        }));
        this.isEditorOpened = false;
        this.handleReturnAutoSave = debounce(this.handleSaveAction, 800);
        this.filteredFunctions = [];
        this.allFunctions = [];
        this.selectedFunction = undefined;
        this.filterFunctionName = '';
        this.init();
        this.debouncedSearch = debounce(this.filterFunctions, 500);
        this.actions = new FunctionViewModel();
    }
    async init() {
        this.$scope.$watch('$ctrl.action.settings.outputVariable', (oldValue, newValue) => {
            this.$timeout(this.handleSaveAction.bind(this));
        });
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
        this.initializeListeners();
        this.updateActionInputVariables();
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        try {
            this.allFunctions = await this.FunctionService.getAllFunctions();
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        catch (e) {
            throw e;
        }
        finally {
            this.isLoading = false;
        }
        this.filteredFunctions = [...this.allFunctions];
        if (this.action.settings.source) {
            this.selectedFunction = this.filteredFunctions.find(f => f.functionId === this.action.settings.source);
        }
    }
    async initializeListeners() {
        const isBuilderUndoRedoActionEnabled = await BuilderFeatures.builderUndoRedoActionEnabled();
        if (isBuilderUndoRedoActionEnabled) {
            this.$rootScope.$on(ACTION_UNDO_REDO_CHANGES, () => this.updateActionInputVariables());
        }
    }
    updateActionInputVariables() {
        this.inputVariables = this.action.settings.inputVariables;
    }
    async deleteFunction(functionId) {
        try {
            const applicationsWithFunction = await this.FunctionService.getApplicationsOfAFunction(functionId);
            if (applicationsWithFunction.length > 0) {
                return;
            }
            await this.FunctionService.deleteFunction(functionId);
            this.getAllFunction();
            this.BlipToastService.show('success', {
                msg: this.$translate.instant('builder-tabs-actions.executeBlipFunction.deletedFunctionToast'),
                duration: 5000,
            });
        }
        catch (e) {
            console.error(e);
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.executeBlipFunction.deletedFunctionToastError'),
                duration: 5000,
            });
        }
    }
    async getAllFunction() {
        try {
            this.allFunctions = await this.FunctionService.getAllFunctions();
            this.filteredFunctions = [...this.allFunctions];
        }
        catch (e) {
            this.allFunctions = [];
            this.filteredFunctions = [...this.allFunctions];
        }
    }
    async backManager() {
        if (this.isEditorOpened) {
            this.closeCodeEditor();
            this.sidebarEditor = undefined;
            this.isEditorOpened = false;
        }
        this.executeAction = true;
        this.createFunction = false;
    }
    async selectFunction(func) {
        this.selectedFunction = func;
        this.action.settings.source = func.functionId;
        try {
            const resource = {
                applicationIdentity: this.application.shortName,
                functionId: func.functionId,
            };
            await this.FunctionService.setFunctionWithApplication(resource);
            this.trackBlockActionLibraryCalledAction();
            this.BlipToastService.show('success', {
                msg: this.$translate.instant('builder-tabs-actions.executeBlipFunction.selectedFunctionToast'),
                duration: 5000,
            });
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.executeBlipFunction.selectedFunctionToastError'),
                duration: 5000,
            });
        }
        this.handleSaveAction();
    }
    async clearSelectedFunction() {
        try {
            await this.FunctionService.deleteFunctionWithApplication(this.application.shortName, this.selectedFunction.functionId);
            this.BlipToastService.show('success', {
                msg: this.$translate.instant('builder-tabs-actions.executeBlipFunction.removedFunctionToast'),
                duration: 5000,
            });
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.executeBlipFunction.removedFunctionToastError'),
                duration: 5000,
            });
        }
        this.selectedFunction = undefined;
        this.action.settings.source = undefined;
        this.handleSaveAction();
    }
    editFunction(func) {
        this.executeAction = false;
        this.createFunction = true;
        this.actions.key = func.functionId;
        this.actions.functionName = func.functionName;
        this.actions.functionContent = func.functionContent;
        this.actions.inputVariables =
            func.functionParameters && func.functionParameters.trim() !== ''
                ? func.functionParameters.split(',')
                : [];
        this.actions.description = func.functionDescription;
        this.keyError = '';
        this.contentError = '';
        this.isEditing = true;
    }
    createFunctionAction() {
        this.actions = new FunctionViewModel();
        this.executeAction = false;
        this.createFunction = true;
        this.keyError = '';
        this.contentError = '';
        this.isEditing = false;
    }
    create() {
        return new ExecuteBlipFunctionActionSettings();
    }
    getContainerHeight() {
        if (this.selectedFunction) {
            return undefined;
        }
        const visibleItemsCount = this.filteredFunctions.length;
        const height = Math.min(visibleItemsCount * this.itemHeight, this.maxHeight);
        return `${height}px`;
    }
    validateOutputVariable() {
        const isValid = this.checkRegexVariable();
        this.returnValueForm.returnValue.$invalid = isValid;
        this.returnValueForm.returnValue.$valid = !isValid;
        this.returnValueForm.returnValue.$setDirty();
    }
    handleSaveAction() {
        this.validateOutputVariable();
        this.save();
    }
    checkRegexVariable() {
        return (this.action.settings.outputVariable &&
            !this.action.settings.outputVariable.match(VARIABLE_VALIDATION_REGEX));
    }
    onInputTitleBlur() {
        this.isEditing = false;
        if (this.action.$title.length === 0) {
            this.action.$title = this.$translate.instant('builder-tabs-actions.executeBlipFunction.title');
            this.handleSaveAction();
        }
    }
    startEditingInputTitle() {
        const input = document.getElementById('execute-blipfunction-title');
        if (input) {
            input.focus();
        }
    }
    toggleCodeEditor() {
        if (this.isEditorOpened) {
            this.closeCodeEditor();
        }
        else {
            this.openCodeEditor();
        }
    }
    editorWasCreated({ editor }) {
        this.isMonacoLoading = false;
        setTimeout(() => {
            editor.layout();
        }, 500);
    }
    closeCodeEditor() {
        this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        this.sidebarEditor = undefined;
        this.isEditorOpened = false;
    }
    async openCodeEditor() {
        this.isEditorOpened = true;
        await this.getAllFunction();
        this.selectedFunction = this.allFunctions.find(func => func.functionId === this.actions.key);
        this.actions.functionContent = this.selectedFunction.functionContent;
        this.sidebarEditor = await this.CodeEditorService.openCodeEditor({
            code: this.actions.functionContent,
            language: 'javascript',
            editorWasCreated: this.editorWasCreated.bind(this),
            SidebarContentService: this.SidebarContentService,
            onCodeEditorChange: ({ code }) => {
                this.actions.functionContent = code;
            },
            onSaveSource: () => {
                this.actions.functionContent = this.actions.functionContent;
            },
            onclose: () => {
                this.isEditorOpened = false;
            },
        });
        const deregisterCloseEditorEvent = this.$rootScope.$on('CloseEditorIfOpenedEvent', () => {
            this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        });
        await this.sidebarEditor.closeDeferred.promise;
        deregisterCloseEditorEvent();
        this.isEditorOpened = false;
    }
    async saveChanges() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
                this.sidebarEditor = undefined;
                this.isEditorOpened = false;
            }
            const validate = await this.validateInputs(this.actions.functionName, this.actions.key, this.actions.functionContent);
            if (!validate) {
                return;
            }
            const resource = FunctionResourceMapper.mapToResource(this.actions);
            if (this.actions.key && this.actions.key.trim() !== '') {
                await this.FunctionService.updateFunction(this.actions.key, resource);
            }
            else {
                await this.FunctionService.setFunction(resource);
            }
            this.BlipToastService.show('success', {
                msg: this.$translate.instant('builder-tabs-actions.message.success.created'),
                duration: 5000,
            });
            this.BuilderSegmentService.trackBlockActionLibraryFunctionCreated({
                Location: 'Library',
                Description: 'Quando o usuário clica no botão Criar função ao preencher os campos de uma nova função',
            });
            this.executeAction = true;
            this.createFunction = false;
            this.allFunctions = await this.FunctionService.getAllFunctions();
            this.filteredFunctions = [...this.allFunctions];
            this.$timeout(() => {
                this.actions.functionContent =
                    this.selectedFunction?.functionContent || '';
                this.$scope.$apply();
            });
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.message.error.created'),
                duration: 5000,
            });
        }
    }
    async checkNameExistsWithAnotherId(functionName, functionId) {
        try {
            const foundFunction = this.allFunctions.find(func => func.functionName === functionName &&
                functionId !== func.functionId);
            if (foundFunction) {
                return true;
            }
            return false;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    async validateInputs(functionName, functionId, functionContent) {
        this.keyError = '';
        this.contentError = '';
        if (!functionName &&
            functionName.trim() === '' &&
            !functionContent &&
            functionContent.trim() === '') {
            const createError = await this.$translate('builder-tabs-actions.functions.createFunction.sessionKey.inputNotEmptyError');
            this.keyError = createError;
            const createErrorContent = await this.$translate('builder-tabs-actions.functions.createFunction.sessionFunctionContent.inputNotEmptyError');
            this.contentError = createErrorContent;
        }
        else if (await this.checkNameExistsWithAnotherId(functionName, functionId)) {
            const createError = await this.$translate('builder-tabs-actions.functions.createFunction.sessionKey.inputAlreadyExistError');
            this.keyError = createError;
            this.contentError = '';
        }
        else if (!functionName && functionName.trim() === '') {
            const createError = await this.$translate('builder-tabs-actions.functions.createFunction.sessionKey.inputNotEmptyError');
            this.keyError = createError;
            this.contentError = '';
        }
        else if (!functionContent && functionContent.trim() === '') {
            const createError = await this.$translate('builder-tabs-actions.functions.createFunction.sessionFunctionContent.inputNotEmptyError');
            this.contentError = createError;
            this.keyError = '';
        }
        if (this.keyError !== '' || this.contentError !== '') {
            return false;
        }
        return true;
    }
    trackBlockActionLibraryCalledAction() {
        this.BuilderSegmentService.trackBlockActionLibraryCalledAction({
            Description: 'Quando o usuário seleciona uma função na lista dentro da ação ”Função da Biblioteca”',
        }, true);
    }
    trackBlockActionLibrarySearch() {
        this.BuilderSegmentService.trackBlockActionLibrarySearch({
            Location: 'ActionLibraryFunction',
            Description: 'Quando o usuário pesquisa algo no campo de input',
        }, true);
    }
    trackBlockActionLibraryMoreOptions(choice) {
        this.BuilderSegmentService.trackBlockActionLibraryMoreOptions({
            Location: 'ActionLibraryFunction',
            Description: 'Quando o usuário clica em alguma opção dentro do ícone ’Mais opções’ na listagens de funções',
            Choice: choice,
        });
    }
    async showEditFunctionUniqueModal() {
        const modal = await this.ModalService.showModal(editFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            this.saveChanges();
        }
    }
    async showEditFunctionMultipleModal() {
        const modal = await this.ModalService.showModal(editFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            this.saveChanges();
        }
    }
    async handleSaveChanges() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
                this.sidebarEditor = undefined;
                this.isEditorOpened = false;
            }
            this.ActionService.setActions(this.actions);
            const applicationsWithFunction = await this.FunctionService.getApplicationsOfAFunction(this.actions.key);
            this.applications = applicationsWithFunction;
            this.actions.applications = applicationsWithFunction;
            this.applications.forEach(application => {
                const serverUrl = window.location.origin;
                application.url = `${serverUrl}/application/detail/${application.applicationIdentity}/templates/builder/`;
            });
            this.BuilderSegmentService.trackBlockActionLibraryEditFunction({
                Location: 'Library',
                Description: 'Quando o usuário clica em Salvar alterações, após fazer alguma alteração em uma função criada.',
            });
            switch (applicationsWithFunction.length) {
                case 0:
                    await this.showEditFunctionUniqueModal();
                    break;
                default:
                    await this.showEditFunctionMultipleModal();
                    break;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    async deleteFunctionWithApplication(applicationIdentity, functionId) {
        try {
            await this.FunctionService.deleteFunctionWithApplication(applicationIdentity, functionId);
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.message.error.deleted'),
                duration: 5000,
            });
        }
    }
    async handleDeleteWithId(func) {
        this.actions.key = func.functionId;
        this.actions.functionName = func.functionName;
        this.actions.functionContent = func.functionContent;
        this.actions.inputVariables =
            func.functionParameters && func.functionParameters.trim() !== ''
                ? func.functionParameters.split(',')
                : [];
        this.actions.description = func.functionDescription;
        await this.handleDelete();
    }
    async delete() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
            }
            if (this.actions.key) {
                if (this.applications.length === 1) {
                    await this.deleteFunctionWithApplication(this.applications[0].applicationIdentity, this.applications[0].functionId);
                }
                await this.FunctionService.deleteFunction(this.actions.key);
                this.BuilderSegmentService.trackBlockActionLibraryDeleteFunction({
                    Location: 'Library',
                    Description: 'É disparado quando o usuário está na tela de edição da função e clica no botão de excluir.',
                });
                this.BlipToastService.show('success', {
                    msg: this.$translate.instant('builder-tabs-actions.message.success.deleted'),
                    duration: 5000,
                });
                this.executeAction = true;
                this.createFunction = false;
                this.getAllFunction();
            }
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: this.$translate.instant('builder-tabs-actions.message.error.deleted'),
                duration: 5000,
            });
        }
    }
    async showDeleteFunctionUniqueModal() {
        const modal = await this.ModalService.showModal(deleteFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            await this.delete();
        }
    }
    async showDeleteFunctionMultipleModal() {
        const modal = await this.ModalService.showModal(deleteFunctionModal({
            confirm: async (choose) => {
                return choose;
            },
        }));
    }
    async handleDelete() {
        try {
            if (this.isEditorOpened) {
                this.closeCodeEditor();
            }
            this.ActionService.setActions(this.actions);
            const applicationsWithFunction = await this.FunctionService.getApplicationsOfAFunction(this.actions.key);
            this.applications = applicationsWithFunction;
            this.actions.applications = applicationsWithFunction;
            this.applications.forEach(application => {
                const serverUrl = window.location.origin;
                application.url = `${serverUrl}/application/detail/${application.applicationIdentity}/templates/builder/`;
            });
            this.BuilderSegmentService.trackBlockActionLibraryDeleteFunction({
                Location: 'Library',
                Description: 'É disparado quando o usuário está na tela de edição da função e clica no botão de excluir.',
            });
            switch (applicationsWithFunction.length) {
                case 0:
                    await this.showDeleteFunctionUniqueModal();
                    break;
                default:
                    await this.showDeleteFunctionMultipleModal();
                    break;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
}
ExecuteBlipFunctionActionController.$inject = ['close', 'action', '$onStateChanged', '$translate', '$rootScope', 'UndoRedoService', 'state', '$timeout', 'CurrentApplicationService', 'FunctionService', 'BlipToastService', 'SidebarContentService', 'CodeEditorService', 'ModalService', 'ActionService', '$scope', 'typeOfAction', 'onOpenSchemaEditor'];
